const MEDIA_MIME_TYPES: Record<string, string> = {
  png: 'image/png',
  jpg: 'image/jpeg',
  jpeg: 'image/jpeg',
  webp: 'image/webp',
  gif: 'image/gif',
  svg: 'image/svg+xml',
  mp4: 'video/mp4',
  webm: 'video/webm',
  mov: 'video/quicktime',
};

export function resolveFileInfo(
  url: string,
  fallbackFileName: string,
): { fileName: string; mimeType?: string } {
  const sanitizedUrl = url.split('?')[0];
  const urlExtensionMatch = sanitizedUrl.match(/\.([a-z0-9]+)$/i);
  const inferredExtension = urlExtensionMatch?.[1]?.toLowerCase();

  const fallbackHasExtension = fallbackFileName.includes('.');
  const fallbackBaseName = fallbackHasExtension
    ? fallbackFileName.slice(0, fallbackFileName.lastIndexOf('.'))
    : fallbackFileName;
  const fallbackExtension = fallbackHasExtension
    ? fallbackFileName.slice(fallbackFileName.lastIndexOf('.') + 1)
    : undefined;

  const resolvedExtension = inferredExtension || fallbackExtension;
  const mimeType = resolvedExtension
    ? MEDIA_MIME_TYPES[resolvedExtension]
    : undefined;

  const fileName =
    resolvedExtension && fallbackBaseName
      ? `${fallbackBaseName}.${resolvedExtension}`
      : fallbackFileName;

  return { fileName, mimeType };
}
